import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { httpService } from "utils";

import { useReactQuery } from "components/RemoteData";

export const useGetResetPasswordEmail = (tokenId: string) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  return useReactQuery(getResetPasswordEmailKey(tokenId), () =>
    getResetPasswordEmail(friendlyUrl, tokenId)
  );
};

export const getResetPasswordEmail = (
  friendlyUrl: string,
  tokenId: string
): Promise<{ email: string }> => {
  return httpService().get<{ email: string }>(
    `/e-reservation/get-user-email/${tokenId}`
  );
};

export const getResetPasswordEmailKey = (tokenId: string) => {
  return `reset-password-${tokenId}`;
};
